var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-checkbox"},[_c('label',{attrs:{"for":_vm.name}},[_c('input',{attrs:{"type":"checkbox","name":_vm.name,"id":_vm.name},domProps:{"value":_vm.value,"checked":_vm.value},on:{"change":_vm.onChange}}),_vm._v(" "),_c('span'),_vm._v(" "),_c('div',{staticClass:"form-checkbox__label"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fef934e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseCheckbox.vue
// module id = null
// module chunks = 